(function ($, window) {
	'use strict';

	$(function () {
		document.querySelectorAll('a[href^="#"]').forEach(link => {
			link.addEventListener('click', (e) => {
				e.preventDefault();

				if (!link.hash) return;

				const target = document.querySelector(link.hash);

				if (target) {
					target.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					});
				}
			});
		});
	});
})(jQuery, window);
